<template>
  <div
    class="
      col-span-6
      sm:col-span-3
      xl:col-span-2
      flex flex-col
      justify-end
      items-center
    "
    v-show="loading"
  >
    <LoadingIcon icon="three-dots" class="w-8 h-8" />
  </div>
  <div>
    <form class="validate-form" @submit.prevent="handleSave" v-show="!loading">
      <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
        <GiftIcon />
        <h2 class="text-lg font-medium mr-auto">{{ $t('loyalty.text') }}</h2>
        <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
          <button
            type="submit"
            class="btn btn-primary shadow-md flex items-center"
          >
            <SaveIcon class="w-4 h-4 mr-2" /> {{ $t('common.save') }}
          </button>
        </div>
      </div>
      <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
        <!-- BEGIN: Post Info -->
        <div class="col-span-12">
          <div class="intro-y box p-5">
            <div class="mt-3">
              <label
                for="name"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('common.name') }}
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }},
                  {{ $t('form.constraint.gte2ch') }}
                </span>
              </label>
              <input
                id="name"
                v-model.trim="validate.name.$model"
                type="text"
                name="name"
                class="
                  intro-y
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                "
                :class="{ 'border-theme-6': validate.name.$error }"
                placeholder="My Company"
              />
              <template v-if="validate.name.$error">
                <div
                  v-for="(error, index) in validate.name.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="post intro-y overflow-hidden box mt-5">
              <div
                class="
                  post__tabs
                  nav nav-tabs
                  flex-col
                  sm:flex-row
                  bg-gray-300
                  dark:bg-dark-2
                  text-gray-600
                "
                role="tablist"
              >
                <a
                  id="sk-tab"
                  data-toggle="tab"
                  data-target="#sk"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center active"
                  role="tab"
                  aria-controls="sk"
                  aria-selected="true"
                >
                  <country-flag country="sk" size="small" />
                  {{ $t('common.language.sk_SK') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#en"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="en"
                  aria-selected="false"
                >
                  <country-flag country="gb" size="small" />
                  {{ $t('common.language.en_UK') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#cs"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="cs"
                  aria-selected="false"
                >
                  <country-flag country="cz" size="small" />
                  {{ $t('common.language.cs_CZ') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#de"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="de"
                  aria-selected="false"
                >
                  <country-flag country="de" size="small" />
                  {{ $t('common.language.de_DE') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#pl"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="pl"
                  aria-selected="false"
                >
                  <country-flag country="pl" size="small" />
                  {{ $t('common.language.pl_PL') }}
                </a>
              </div>
              <div class="tab-content">
                <div
                  class="tab-pane active"
                  id="sk"
                  role="tabpanel"
                  aria-labelledby="sk-tab"
                >
                  <div class="mt-3">
                    <label
                      for="shortDescriptionSk"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.shortDescription') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="shortDescriptionSk"
                      v-model.trim="validate.shortDescriptionSk.$model"
                      type="text"
                      name="shortDescriptionSk"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{
                        'border-theme-6': validate.shortDescriptionSk.$error
                      }"
                    />
                    <label
                      for="descriptionSk"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionSk"
                      name="descriptionSk"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionSk"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="en"
                  role="tabpanel"
                  aria-labelledby="en-tab"
                >
                  <div class="mt-3">
                    <label
                      for="shortDescriptionEn"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.shortDescription') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="shortDescriptionEn"
                      v-model.trim="validate.shortDescriptionEn.$model"
                      type="text"
                      name="shortDescriptionEn"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{
                        'border-theme-6': validate.shortDescriptionEn.$error
                      }"
                    />
                    <label
                      for="descriptionEn"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionEn"
                      name="descriptionEn"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionEn"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="cs"
                  role="tabpanel"
                  aria-labelledby="cs-tab"
                >
                  <div class="mt-3">
                    <label
                      for="shortDescriptionCs"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.shortDescription') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="shortDescriptionCs"
                      v-model.trim="validate.shortDescriptionCs.$model"
                      type="text"
                      name="shortDescriptionCs"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{
                        'border-theme-6': validate.shortDescriptionCs.$error
                      }"
                    />
                    <label
                      for="descriptionCs"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionCs"
                      name="descriptionCs"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionCs"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="de"
                  role="tabpanel"
                  aria-labelledby="de-tab"
                >
                  <div class="mt-3">
                    <label
                      for="shortDescriptionDe"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.shortDescription') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="shortDescriptionDe"
                      v-model.trim="validate.shortDescriptionDe.$model"
                      type="text"
                      name="shortDescriptionDe"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{
                        'border-theme-6': validate.shortDescriptionDe.$error
                      }"
                    />
                    <label
                      for="descriptionDe"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionDe"
                      name="descriptionDe"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionDe"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="pl"
                  role="tabpanel"
                  aria-labelledby="pl-tab"
                >
                  <div class="mt-3">
                    <label
                      for="shortDescriptionPl"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.shortDescription') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="shortDescriptionPl"
                      v-model.trim="validate.shortDescriptionPl.$model"
                      type="text"
                      name="shortDescriptionPl"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{
                        'border-theme-6': validate.shortDescriptionPl.$error
                      }"
                    />
                    <label
                      for="descriptionPl"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionPl"
                      name="descriptionPl"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionPl"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <template v-if="validate.shortDescriptionSk.$error">
                  <div
                    v-for="(error, index) in validate.shortDescriptionSk
                      .$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
                <template v-if="validate.shortDescriptionEn.$error">
                  <div
                    v-for="(error, index) in validate.shortDescriptionEn
                      .$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
                <template v-if="validate.shortDescriptionCs.$error">
                  <div
                    v-for="(error, index) in validate.shortDescriptionCs
                      .$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
                <template v-if="validate.shortDescriptionDe.$error">
                  <div
                    v-for="(error, index) in validate.shortDescriptionDe
                      .$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
                <template v-if="validate.shortDescriptionPl.$error">
                  <div
                    v-for="(error, index) in validate.shortDescriptionPl
                      .$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
            </div>
            <div class="mt-3">
              <ImageUploader
                ref="imageUploader"
                :defaultImage="loyalty.image"
              />
            </div>
          </div>
        </div>
        <!-- END: Post Info -->
      </div>
    </form>
  </div>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('loyalty.updated') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('loyalty.notUpdated') }}!</div>
      <!-- <div class="text-gray-600 mt-1">{{ errorNote }}</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div
    id="failed-load-notification-content"
    class="toastify-content hidden flex"
  >
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('loyalty.notLoaded') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, toRefs, reactive, ref } from 'vue'
import { required, minLength, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Toastify from 'toastify-js'
import providerApi from '@/services/providers/provider.api'
import ImageUploader from '@/components/cdn/ImageUploader.vue'

export default defineComponent({
  components: {
    ImageUploader
  },
  methods: {
    handleSave(data) {
      this.loading = true

      const imageUrl = this.$refs.imageUploader.getValue()

      this.validate.$touch()
      if (this.validate.$invalid) {
        Toastify({
          node: cash('#failed-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.loading = false
        return
      }

      const saveRequest = {
        name: data.target.elements.name.value,
        shortDescription: {
          sk_SK: data.target.elements.shortDescriptionSk.value,
          en_US: data.target.elements.shortDescriptionEn.value,
          cs_CZ: data.target.elements.shortDescriptionCs.value,
          de_DE: data.target.elements.shortDescriptionDe.value,
          pl_PL: data.target.elements.shortDescriptionPl.value
        },
        description: {
          sk_SK: this.descriptionSk,
          en_US: this.descriptionEn,
          cs_CZ: this.descriptionCs,
          de_DE: this.descriptionDe,
          pl_PL: this.descriptionPl
        },
        image: imageUrl === null ? this.loyalty.image : imageUrl
      }
      console.log(saveRequest)

      providerApi.updateLoyaltyText(saveRequest).then(
        response => {
          Toastify({
            node: cash('#success-notification-content')
              .clone()
              .removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.loyalty = response.data.loyalty

          this.formData.name = response.data.title
          this.formData.shortDescriptionSk =
            response.data.loyalty.shortDescription.sk_SK
          this.formData.shortDescriptionEn =
            response.data.loyalty.shortDescription.en_US
          this.formData.shortDescriptionCs =
            response.data.loyalty.shortDescription.cs_CZ
          this.formData.shortDescriptionDe =
            response.data.loyalty.shortDescription.de_DE
          this.formData.shortDescriptionPl =
            response.data.loyalty.shortDescription.pl_PL
          this.descriptionSk = response.data.loyalty.description.sk_SK
          this.descriptionEn = response.data.loyalty.description.en_US
          this.descriptionCs = response.data.loyalty.description.cs_CZ
          this.descriptionDe = response.data.loyalty.description.de_DE
          this.descriptionPl = response.data.loyalty.description.pl_PL

          this.loading = false
        },
        error => {
          console.log(error)
          this.loading = false
          Toastify({
            node: cash('#failed-notification-content')
              .clone()
              .removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
        }
      )
    }
  },
  data() {
    return {
      loyalty: {}
    }
  },
  mounted() {
    providerApi.getDetail().then(
      response => {
        this.loyalty = response.data.loyalty

        this.formData.name = response.data.title
        this.formData.shortDescriptionSk =
          response.data.loyalty.shortDescription.sk_SK
        this.formData.shortDescriptionEn =
          response.data.loyalty.shortDescription.en_US
        this.formData.shortDescriptionCs =
          response.data.loyalty.shortDescription.cs_CZ
        this.formData.shortDescriptionDe =
          response.data.loyalty.shortDescription.de_DE
        this.formData.shortDescriptionPl =
          response.data.loyalty.shortDescription.pl_PL
        this.descriptionSk = response.data.loyalty.description.sk_SK
        this.descriptionEn = response.data.loyalty.description.en_US
        this.descriptionCs = response.data.loyalty.description.cs_CZ
        this.descriptionDe = response.data.loyalty.description.de_DE
        this.descriptionPl = response.data.loyalty.description.pl_PL

        this.loading = false
      },
      error => {
        console.log(error)
        Toastify({
          node: cash('#failed-load-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.$router.push({ name: 'side-menu-branches' })
      }
    )
  },
  computed: {
    console: () => console
  },
  setup() {
    const loading = ref(true)
    const descriptionSk = ref('')
    const descriptionEn = ref('')
    const descriptionCs = ref('')
    const descriptionDe = ref('')
    const descriptionPl = ref('')
    const formData = reactive({
      name: '',
      shortDescriptionSk: '',
      shortDescriptionEn: '',
      shortDescriptionCs: '',
      shortDescriptionDe: '',
      shortDescriptionPl: ''
    })
    const rules = {
      name: {
        required: helpers.withMessage(
          'form.validation.shortDescriptionSk.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      shortDescriptionSk: {
        required: helpers.withMessage(
          'form.validation.shortDescriptionSk.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      shortDescriptionEn: {
        required: helpers.withMessage(
          'form.validation.shortDescriptionEn.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      shortDescriptionCs: {
        required: helpers.withMessage(
          'form.validation.shortDescriptionCs.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      shortDescriptionDe: {
        required: helpers.withMessage(
          'form.validation.shortDescriptionDe.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      shortDescriptionPl: {
        required: helpers.withMessage(
          'form.validation.shortDescriptionPl.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      }
    }
    const validate = useVuelidate(rules, toRefs(formData))

    return {
      loading,
      validate,
      formData,
      descriptionSk,
      descriptionEn,
      descriptionCs,
      descriptionDe,
      descriptionPl
    }
  }
})
</script>
